import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCcZfG87q6eNAib3C8VNclzXe3U2MyG13U",
  authDomain: "recruitintell-e0d42.firebaseapp.com",
  projectId: "recruitintell-e0d42",
  storageBucket: "recruitintell-e0d42.appspot.com",
  messagingSenderId: "991172120396",
  appId: "1:991172120396:web:f93e36211ae823812849e9",
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
